import "./BackToTop.scss";
import { define, mount } from "../../../Lib/registry";
import type { Component } from "../../../Lib/types";

const SHOW_THRESHOLD = 200;

class BackToTop implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    mount(el);
    this.init();
  }

  private init(): void {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.el.addEventListener("click", this.scrollToTop);
    this.onScroll();
  }

  private onScroll = (): void => {
    const scrollTop = window.scrollY;
    const scrollable =
      document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollable > 0 ? (scrollTop / scrollable) * 100 : 0;

    this.el.style.setProperty("--back-to-top-progress", progress.toFixed(2));

    this.el.classList.toggle(
      "back-to-top--visible",
      scrollTop > SHOW_THRESHOLD
    );
  };

  private scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  destroy(): void {
    window.removeEventListener("scroll", this.onScroll);
    this.el.removeEventListener("click", this.scrollToTop);
  }
}

define("back-to-top", (el) => new BackToTop(el));
export { BackToTop };
